import React from 'react';
import { Button, Modal } from 'antd-mobile';

export default ({ t, errorText }) => {
	const handleClose = () => {
		// 关闭弹窗
		modal.close();
	};

	const modal = Modal.show({
		content: (
			<div className='rc-alert'>
				<div className='rc-alert-bd'>
					<p>{errorText}</p>
				</div>
				<div className='rc-alert-ft'>
					<Button className='rc-alert-btn' onClick={handleClose}>
						{t('redeem.popup_iKnow')}
					</Button>
				</div>
			</div>
		),
		closeOnMaskClick: true,
	});
};
